import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="relative border-t border-blue-900/30 mt-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo-anjora.svg" alt="Anjora" className="h-12 w-12 object-contain" />
              <span className="text-white text-2xl font-extrabold">Anjora</span>
            </div>
            <p className="text-white/55 text-sm max-w-sm leading-relaxed">
              Proteção inteligente contra o vício em apostas online. Feito no Brasil, para brasileiros.
            </p>
          </div>

          <div>
            <p className="text-white text-sm font-semibold mb-4">Produto</p>
            <ul className="space-y-2 text-sm text-white/55">
              <li><a href="#como-funciona" className="hover:text-white transition-colors">Como funciona</a></li>
              <li><a href="#faq" className="hover:text-white transition-colors">FAQ</a></li>
              <li><a href="#planos" className="hover:text-white transition-colors">Planos</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Baixar</a></li>
            </ul>
          </div>

          <div>
            <p className="text-white text-sm font-semibold mb-4">Legal</p>
            <ul className="space-y-2 text-sm text-white/55">
              <li><Link to="/privacidade" className="hover:text-white transition-colors">Política de Privacidade</Link></li>
              <li><Link to="/termos" className="hover:text-white transition-colors">Termos de Uso</Link></li>
              <li><a href="mailto:suporte@anjora.com.br" className="hover:text-white transition-colors">suporte@anjora.com.br</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-blue-900/30 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">© 2026 Anjora. Todos os direitos reservados.</p>
          <div className="flex gap-4 text-white/40 text-xs">
            <Link to="/privacidade" className="hover:text-white transition-colors">Privacidade</Link>
            <Link to="/termos" className="hover:text-white transition-colors">Termos</Link>
            <p>Feito com cuidado em 🇧🇷</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
